/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Exact_Alarm_TitleInputs */

const en_us2_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rest alarm may be late`)
};

const pt_br2_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O alarme do descanso pode atrasar`)
};

const es_419_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La alarma del descanso puede retrasarse`)
};

const pt_pt2_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O alarme do descanso pode atrasar`)
};

const fr_fr2_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'alarme de repos risque d'être en retard`)
};

const de_de2_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Pausenalarm kommt evtl. zu spät`)
};

const it_it2_offline_exact_alarm_title = /** @type {(inputs: Offline_Exact_Alarm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sveglia del recupero potrebbe ritardare`)
};

/**
* | output |
* | --- |
* | "The rest alarm may be late" |
*
* @param {Offline_Exact_Alarm_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_exact_alarm_title = /** @type {((inputs?: Offline_Exact_Alarm_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Exact_Alarm_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_exact_alarm_title(inputs)
	if (locale === "es-419") return es_419_offline_exact_alarm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_exact_alarm_title(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_exact_alarm_title(inputs)
	if (locale === "de-DE") return de_de2_offline_exact_alarm_title(inputs)
	if (locale === "it-IT") return it_it2_offline_exact_alarm_title(inputs)
	return en_us2_offline_exact_alarm_title(inputs)
});
export { offline_exact_alarm_title as "offline.exact_alarm_title" }